/**
 * Feature flag utilities
 * Centralised feature flag checks based on env variables
 */

/**
 * Check if the current environment is production
 * Production is identified by the 'ecofy.co.in' domain in the API URL
 */
export const isProduction = () => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL || '';
  return apiUrl.includes('ecofy.co.in');
};

/**
 * Check if the Help Request feature is enabled
 * - If VITE_ENABLE_HELP_REQUEST is explicitly set, use that value
 * - Otherwise, enabled by default in non-production (dev/preprod), disabled in production
 */
export const isHelpRequestEnabled = () => {
  const envValue = import.meta.env.VITE_ENABLE_HELP_REQUEST;

  // If explicitly set, respect the value
  if (envValue === 'true') return true;
  if (envValue === 'false') return false;

  // Default: enabled everywhere except production
  return !isProduction();
};
